import { jsx as _jsx } from "react/jsx-runtime";
import { reportErrorToBugsnag } from "@air/utils-error";
import noop from "lodash/noop";
import { createContext, memo, useCallback, useContext, useMemo, useRef, useState } from "react";
import { isDevOrTestStage } from "~/swr-hooks/utils";
const defaultKanbanFetchPageContextValue = {
    hasNextPage: false,
    isFetchingNextPage: false,
    fetchNextPage: noop,
    setFetchNextPage: noop,
    setIsFetchingNextPage: noop,
    setHasNextPage: noop
};
export const KanbanFetchPageContext = /*#__PURE__*/ createContext(defaultKanbanFetchPageContextValue);
export const KanbanFetchPageProvider = /*#__PURE__*/ memo((param)=>{
    let { children } = param;
    const [hasNextPage, setHasNextPage] = useState(false);
    const [isFetchingNextPage, setIsFetchingNextPage] = useState(false);
    const fetchNextPageRef = useRef(noop);
    const fetchNextPage = useCallback(()=>{
        fetchNextPageRef.current();
    }, []);
    const setFetchNextPage = useCallback((fetchNextPage)=>{
        fetchNextPageRef.current = fetchNextPage;
    }, []);
    const value = useMemo(()=>({
            hasNextPage,
            isFetchingNextPage,
            fetchNextPage,
            setFetchNextPage,
            setIsFetchingNextPage,
            setHasNextPage
        }), [
        hasNextPage,
        isFetchingNextPage,
        fetchNextPage,
        setFetchNextPage
    ]);
    return /*#__PURE__*/ _jsx(KanbanFetchPageContext.Provider, {
        value: value,
        children: children
    });
});
KanbanFetchPageProvider.displayName = "KanbanFetchPageProvider";
export const useKanbanFetchPageContext = ()=>{
    const context = useContext(KanbanFetchPageContext);
    if (context === defaultKanbanFetchPageContextValue) {
        const error = "KanbanFetchPageContext used outside of KanbanFetchPageProvider";
        if (isDevOrTestStage()) {
            throw error;
        } else {
            reportErrorToBugsnag({
                error,
                context: error
            });
        }
    }
    return context;
};
